export default {
  enabled: true,
  basePath: '/download',
};
